import { EditorDuplicateAction } from "./EditorDuplicateAction";
export default EditorDuplicateAction;
export * from "./EditorDuplicateAction";
